import React from 'react';
import { Redirect } from 'react-router-dom';
import Yorum from 'src/views/Chat';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import OverView from 'src/views/Overview';
import ClosedJob from 'src/views/ClosedJob';
import UndatedWorkOrder from 'src/views/UndatedWorkOrder';
import Profil from 'src/views/Profile';
import Isler from 'src/views/WorkOrder';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import BultenlerView from './views/Bulletin';
import TodaySummaryView from './views/TodaySummary';
import DosyaView from './views/File';
import YardimView from './views/Help';
import MalzemeIhtiyacView from './views/MaterialRequirement';
import ProdcutDetailControlView from './views/ProductDetailControl';
import ServisIletisimView from './views/ServiceContact';
import UyariMerkeziView from './views/WarningCenter';
import MaterialOrderView from './views/MaterialOrder';
import TechnicalKnowledgeBase from './views/TechnicalKnowledgeBase';
import ProductReleaseView from './views/ProductRelease';
import Dashboard from './views/Dashboard';
import TechnicianShopOffWorkView from './views/TechnicianOffWork'
import ForPartner from './views/MaterialOrder/Create/ForPartner';
import ForConsumer from 'src/views/MaterialOrder/Create/ForConsumer';
import Query from './views/MaterialOrder/Query';
import Return from './views/MaterialOrder/Return';
import MyReturnsReport from './views/MaterialOrder/MyReturnsReport';
import PendingJobs from './views/PendingJobs';
import ActionRequired from './views/ActionRequired';
import ValueProposition from './views/ValueProposition'
import OwnEngineeringMaterials from './views/OwnEngineerMaterials'
import PartnerReport from './views/PartnerReport';
import Sales from 'src/views/Sales';
import ProductSales from 'src/views/Sales/ProductSales/ProductSales';
import ExtraWarrantySales from 'src/views/Sales/ExtraWarrantySales';
import MaterialSales from 'src/views/Sales/MaterialSales';


export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/chat',
        exact: true,
        component: Yorum
      },
      {
        path: '/chat/:id',
        exact: true,
        component: Yorum
      },
      {
        path: '/dashboard',
        exact: true,
        component: Dashboard
      },
      {
        path: '/dashboards/default',
        exact: true,
        component: TodaySummaryView
      },
      {
        path: '/WorkOrder/:id/:tab',
        exact: true,
        component: Isler
      },
      {
        path: '/PendingJobs',
        exact: true,
        component: PendingJobs
      },
      {
        path: '/ActionRequired',
        exact: true,
        component: ActionRequired
      },
      {
        path: '/overview',
        exact: true,
        component: OverView
      },
      {
        path: '/ClosedJob',
        exact: true,
        component: ClosedJob
      },
      {
        path: '/UndatedWorkOrder',
        exact: true,
        component: UndatedWorkOrder
      },
      {
        path: '/ValueProposition',
        exact: true,
        component: ValueProposition
      },
      {
        path: '/Bultenler',
        exact: true,
        component: BultenlerView
      },
      {
        path: '/Dosya',
        exact: true,
        component: DosyaView
      },
      {
        path: '/ProductDetailControl',
        exact: true,
        component: ProdcutDetailControlView
      },
      {
        path: '/MaterialNeed',
        exact: true,
        component: MalzemeIhtiyacView
      },
      {
        path: '/MaterialOrder',
        exact: true,
        component: MaterialOrderView
      },
      {
        path: '/materialOrder/Query',
        exact: true,
        component: Query
      },
      {
        path: '/materialOrder/Create/ForConsumer',
        exact: true,
        component: ForConsumer
      },
      {
        path: '/materialOrder/Create/ForPartner',
        exact: true,
        component: ForPartner
      },
      {
        path: '/materialOrder/Return',
        exact: true,
        component: Return
      },
      {
        path: '/materialOrder/MyReturnsReport',
        exact: true,
        component: MyReturnsReport
      },
      {
        path: '/OwnEngineeringMaterials',
        exact: true,
        component: OwnEngineeringMaterials
      },
      {
        path: '/UyariMerkezi',
        exact: true,
        component: UyariMerkeziView
      },
      {
        path: '/ProductRelease',
        exact: true,
        component: ProductReleaseView
      },
      {
        path: '/ServisIletisim',
        exact: true,
        component: ServisIletisimView
      },
      {
        path: '/Yardim',
        exact: true,
        component: YardimView
      },
      {
        path: '/TechnicalKnowledgeBase',
        exact: true,
        component: TechnicalKnowledgeBase
      },
      {
        path: '/TechnicianShopOffWork',
        exact: true,
        component: TechnicianShopOffWorkView
      },
      ,
      {
        path: '/TechnicalKnowledgeBase',
        exact: true,
        component: TechnicalKnowledgeBase
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/PartnerReport',
        exact: true,
        component: PartnerReport
      },
      {
        path: '/Sales/Product',
        exact: true,
        component: ProductSales
      },
      {
        path: '/Sales/ExtraWarranty',
        exact: true,
        component: ExtraWarrantySales
      },
      {
        path: '/Sales/Material',
        exact: true,
        component: MaterialSales
      },
      {
        path: '/Sales',
        exact: true,
        component: Sales
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
